module.exports = __webpack_public_path__ + "static/media/mobile_hero_rendering.a057e95d.jpg";